export default "__VITE_ASSET__DcFnjnNq__"